import { useEffect, useRef, useState } from "react";

export const VerseCard = ({ items, note, testId = "verse-card" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => e.isIntersecting && setShown(true), { threshold: 0.2 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return (
    <section ref={ref} className={`verse-card fade-in ${shown ? "is-shown" : ""}`} data-testid={testId}>
      {items.map((v, i) => (
        <div key={v.reference} className="verse-item">
          {i > 0 && <hr className="verse-sep" />}
          <p className="verse-text" data-testid={`${testId}-text-${i + 1}`}>{v.text}</p>
          <p className="verse-ref" data-testid={`${testId}-ref-${i + 1}`}>{v.reference}</p>
        </div>
      ))}
      {note && <p className="verse-note" data-testid={`${testId}-note`}>{note}</p>}
    </section>
  );
};
